/*
 * Layout for the account admin section
 */

define(["marionette", "./template/kbProfileTemplate.html"], function (
  Marionette,
  KbProfileTemplate,
) {
  var KbProfileView = {
    kbProfileLayout: Marionette.Layout.extend({
      template: KbProfileTemplate,
      tagName: "div",
      className: "row-fluid max-height",
      regions: {
        sideMenu: "#kbSideMenu",
        kbPane: "#kbPane",
      },
    }),
  };

  return KbProfileView;
});
